export interface IApplicationInsight {
  connectionString: string | null;
}

export enum Features {
  ServiceAndSupport = 'ServiceAndSupportModule',
  UiTranslation = 'UiTranslation',
  Provisioning = 'Provisioning',
  UserApiKey = 'UserApiKey',
  Notification = 'Notification',
  Faq = 'FaqModule',
  Qlik = 'QlikModule',
  Branch = 'Branch',
}
